import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

/**
 * Checks a password reset link before the form is shown, so an expired or
 * superseded link says so up front instead of failing on submit (86cyqeavf).
 * Links sent before the email was added to the URL skip the check.
 */
export default function useCheckResetPasswordLink({
  email,
  token,
}: {
  email: string | null
  token: string | null
}) {
  return useQuery({
    queryKey: ['reset-password-link', { email, token }],
    queryFn: async () => {
      await httpClient.get('/csrf-cookie')
      const response = await httpClient.post('auth/reset-password/check', {
        email,
        token,
      })
      return response.data
    },
    enabled: !!email && !!token,
    retry: false,
    staleTime: Infinity,
  })
}
